var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"lmy-header"}),_vm._v(" "),_c('div',{staticClass:"lmy-login-main"},[_c('div',{staticClass:"lmy-login-btn",on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdbc8598","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/usr/logOut.vue
// module id = null
// module chunks = 